import Skeleton from '@mui/material/Skeleton';

import { styled } from 'helpers';

import type { SkeletonProps } from '@mui/material/Skeleton';

export const StyledSkeleton = styled(Skeleton)<SkeletonProps>`
  background: ${({ theme }) => theme.palette.grey['A100']};
  &.dark {
    background: rgba(255, 255, 255, 0.16);
  }
  &.dark::after {
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.04), transparent);
  }
  &.MuiSkeleton-text {
    border-radius: 8px;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    transform: none;
  }
  &.MuiSkeleton-rectangular {
    border-radius: 8px;
  }
`;
StyledSkeleton.displayName = 'StyledSkeleton';
